<template>
    <div class="com-codics-book-admin-group-type-body">
        <div class="com-codics-book-admin-group-type-bar-content">
            <el-button class="iconfont" style="float: left;" @click.native="addDialogVisible = true;">&#xe632;
                添加类型</el-button>
        </div>
        <div class="com-codics-book-admin-group-type-bar-content com-codics-book-admin-group-type-bar-content2"
            style="margin-top: 10px;">
            <el-table :data="tableData" style="width: 100%;transition: .3s;" row-key="value"
                :tree-props="{ children: 'data', hasChildren: 'hasChildren' }" show-expand-column default-expand-all>
                <el-table-column prop="id" label="ID" width="120" style="user-select: none;">
                </el-table-column>
                <el-table-column prop="value" label="名称" width="180">
                </el-table-column>
                <el-table-column align="right" label="操作" min-width="150">
                    <template slot-scope="scope">
                        <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info"
                            icon-color="red" title="您确定要删除当前分类数据吗？删除后所有子分类将一并删除！"
                            @confirm="deleteMp4TypeFuc([scope.row.id])">
                            <MyButton v-show="scope.row.member != 0" size="small" type="danger" style="float: right;"
                                slot="reference">删除</MyButton>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog title="添加视频分类" :visible.sync="addDialogVisible" width="800px">
            <el-input v-model="addForm.value" size="small" placeholder="请输入分类名称" clearable
                style="font-size: 12px;width:calc(50% - 7.5px) !important;margin-top:20px;" autocomplete="off"
                maxlength="15" show-word-limit></el-input>
            <el-cascader :options="tableData" placeholder="请选择上级分类"
                style="font-size: 12px !important;width:calc(50% - 7.5px) !important;margin-top:20px;margin-left:15px;margin-bottom:100px;"
                clearable size="small" :props="{ value: 'id', label: 'value', checkStrictly: true, children: 'data' }"
                @change="selectChange">
            </el-cascader>
            <el-button size="small" style="position:absolute !important;bottom:15px;right:15px;"
                @click.native="addMp4TypeFuc">
                确认
            </el-button>
        </el-dialog>
    </div>
</template>

<script>
import dayjs from 'dayjs';
// import MyButton from '@/components/MyButton';
// import MyDialog from '@/components/MyDialog';
import { addMp4Type, deleteMp4Type, updateMp4Type, listMp4Type } from '@/api';
export default {
    data() {
        return {
            addProductDialogVisibility: false,
            formLabelWidth: '60px',
            addDialogVisible: false,
            tableData: [],
            selectData: [],
            addForm: {
                value: '',
                pid: 0
            }
        }
    },
    components: {
        // MyButton,
        // MyDialog
    },
    mounted() {
        this.listMp4TypeFuc();
    },
    methods: {
        async listMp4TypeFuc() {

            const loading = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await listMp4Type();

            loading.close();

            if (data.code == 200) {

                this.tableData = data.data;

                this.initChildren(this.tableData);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async addMp4TypeFuc() {

            if (this.addForm.value == '') {

                this.$message({
                    showClose: true,
                    message: '分类名称不能为空！',
                    type: 'warning'
                });

                return;

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await addMp4Type(this.addForm);

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '添加分类数据成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async deleteMp4TypeFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await deleteMp4Type({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: data.count + '条数据删除成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        initChildren(list) {

            for (var i = 0; i < list.length; i++) {

                if (list[i]?.data != null) {

                    // list[i].hasChildren = true;

                    this.initChildren(list[i].data);

                } else {

                    // delete list[i].children;

                }

            }

        },
        selectChange(val) {

            this.addForm.pid = val.length == 0 ? 0 : val[val.length - 1];

        },
        initTime(str) {
            return dayjs(str).format('YYYY-MM-DD HH:mm:ss');
        }
    }
}
</script>

<style>
.com-codics-book-admin-group-type-body {
    height: calc(100vh - 100px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    overflow-y: scroll;
    width: calc(100% + 20px);
    overflow-y: scroll;
    padding-right: 20px;
}

.com-codics-book-admin-group-type-bar-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: var(--sbar-bg-color);
    border-radius: 6px;
    border: 1px solid var(--sbar-l-3-color);
    padding: 15px;
    transition: .3s;
}

.com-codics-book-admin-group-type-bar-content2 {
    box-sizing: border-box;
    padding: 20px;
}

.com-codics-book-admin-group-type-bar-pick {
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-right: 15px;
}

.com-codics-book-admin-group-type-bar-input {
    width: 300px !important;
    position: relative;
    float: left;
    box-sizing: border-box;
}
</style>